import React from 'react'
import {withNav} from '../../../../core/components/navbar/index'
import VisibleLoggedInHeader from '../containers/VisibleLoggedInHeader'

let LoggedIn = ({className, children}) => {
  return (
    <div className={className ? className : ''}>
      <VisibleLoggedInHeader />
      {children}
    </div>
  )
}
LoggedIn = withNav(LoggedIn, true)
export default LoggedIn



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/components/LoggedIn.js